// The failure codes the app-password endpoints answer with, narrowed to the
// ones the UI has copy for. Kept out of `native-mailbox-api` so the narrowing
// can be tested for real while component tests mock the network client.

// The failures every app-password call shares.
const APP_PASSWORD_FAILURES = ['not_provisioned', 'unauthorized', 'unavailable'] as const

export const CREATE_APP_PASSWORD_REASONS = [
  ...APP_PASSWORD_FAILURES,
  'app_password_quota',
  'invalid_description',
  'rate_limited',
] as const

export type CreateAppPasswordReason = (typeof CREATE_APP_PASSWORD_REASONS)[number]

export const REVOKE_APP_PASSWORD_REASONS = [...APP_PASSWORD_FAILURES, 'unknown_id'] as const

export type RevokeAppPasswordReason = (typeof REVOKE_APP_PASSWORD_REASONS)[number]

// The `error` code of a failed answer, if it is one of `known`. Anything else —
// a body that is not JSON (a proxy 502), a code this client has no copy for
// (`forbidden`, `method_not_allowed`, one added later) — reads as `unavailable`,
// so a failure never renders as nothing.
export async function readFailureReason<Reason extends string>(
  res: Response,
  known: readonly Reason[]
): Promise<Reason | 'unavailable'> {
  const body: unknown = await res.json().catch(() => null)
  const error = typeof body === 'object' && body !== null && 'error' in body ? body.error : undefined
  return known.find((reason) => reason === error) ?? 'unavailable'
}
